import {mediaMatch} from "../../utils";
import {useEffect, useRef, useMemo, useState, useCallback} from "react";
import {useTranslation} from "react-i18next";

export default function ScrollLoadWrap(
  {
    children, className, listHeightOffsetTop, getPage, page, loading, isNoMore
  }
) {
  
  const isMdmax = mediaMatch.isMdmax;
  if (!isMdmax) return (<div className={className}>{children}</div>); // 如果不是手机端直接返回
  
  const ref = useRef();
  let scrollEvent = null;
  let tottlteBottom = 100;
  let timeout = useRef(null);
  const { t } = useTranslation();
  
  const scrollHandle = useCallback((e) => {
    if (timeout.current || loading || isNoMore) return;
    timeout.current = setTimeout(() => {
      let listHeight = ref.current.offsetHeight - listHeightOffsetTop;
      let isBottom = ref.current.scrollHeight <= (e.target.scrollTop + listHeight) + tottlteBottom;
      if (isBottom) {
        getPage({ page: page += 1 });
      }
      
      clearTimeout(timeout.current);
      timeout.current = null;
    }, 300);
  }, []);
  
  useEffect(() => {
    if (isNoMore && ref.current) {
      ref.current.removeEventListener('scroll', scrollHandle);
    }
  }, [isNoMore]);
  
  useEffect(() => {
    if (ref.current) {
      scrollEvent = ref.current.addEventListener('scroll', scrollHandle);
    }
    
    return () => {
      if (scrollEvent) {
        ref.current.removeEventListener('scroll', scrollHandle);
        scrollEvent = null;
      }
    };
    
  }, []);
  
  return (
    <div ref={ref}
         className={`overflow-y-scroll ${className}`}
         style={{ maxHeight: document.documentElement.clientHeight - listHeightOffsetTop }}>
      {children}
      {isNoMore && <p className="py-[12px] text-[13px] text-center">{t('暂无相关订单')}</p>}
    </div>
  );
}
